import { render } from "./HeaderAds.vue?vue&type=template&id=60a6873e&scoped=true"
import script from "./HeaderAds.vue?vue&type=script&lang=js"
export * from "./HeaderAds.vue?vue&type=script&lang=js"

import "./HeaderAds.vue?vue&type=style&index=0&id=60a6873e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a6873e"]])

export default __exports__